import { CountUp } from 'countup.js';

import '../sass/timeline.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-education-swiper-js');
    const $blocks = document.querySelectorAll('.block.timeline');

    if (!$blocks.length) return;

    const animateSlideStats = ($slide) => {
        if (!$slide || $slide.dataset.timelineStatsAnimated === 'true') return;

        const $carousel = $slide.closest('.timeline__carousel');

        if (!$carousel?.classList.contains('is-on-screen')) return;

        const $numbers = $slide.querySelectorAll('.timeline__stat-number');

        if (!$numbers.length) return;

        $slide.dataset.timelineStatsAnimated = 'true';

        $numbers.forEach($number => {
            const counter = new CountUp($number);

            if (!counter.error) {
                counter.start();
            }
        });
    };

    const animateActiveSlideStats = ($carousel) => {
        const $activeSlide = $carousel.querySelector('.swiper-slide-active');

        animateSlideStats($activeSlide);
    };

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.timeline__carousel');
        const $titles = $block.querySelectorAll('.timeline__title');
        const $navigationPrev = $block.querySelector('.timeline__navigation-prev');
        const $navigationNext = $block.querySelector('.timeline__navigation-next');

        const setActiveTitle = (index) => {
            $titles.forEach(($title) => {
                const titleIndex = parseInt($title.dataset.index, 10);

                $title.classList.toggle('timeline__title--active', titleIndex === index);
            });
        };

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 600,
                watchOverflow: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                navigation: {
                    prevEl: $navigationPrev,
                    nextEl: $navigationNext,
                },
                on: {
                    init(swiper) {
                        setActiveTitle(swiper.activeIndex);
                        animateActiveSlideStats($carousel);
                    },
                    slideChange(swiper) {
                        setActiveTitle(swiper.activeIndex);
                        animateActiveSlideStats($carousel);
                    },
                },
            });

            $carousel.addEventListener('onScreen', () => {
                animateActiveSlideStats($carousel);
            });

            if ($carousel.classList.contains('is-on-screen')) {
                animateActiveSlideStats($carousel);
            }

            $titles.forEach($title => {
                $title.addEventListener('click', () => {
                    const index = parseInt($title.dataset.index, 10);

                    if (Number.isNaN(index)) return;

                    carousel.slideTo(index);
                    setActiveTitle(index);
                });
            });
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const loadedSwiperScript = document.querySelector('#ofg-education-swiper-js');

                if (!loadedSwiperScript) return;

                initCarousel();
            });
        }
    });
})();
